var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { TaskBoxService } from "~/services/domain-service/task-box.service";
import { PageService } from "~/utils/page.service";
import { CommonService } from "~/utils/common.service";
import { namespace } from "vuex-class";
import DataForm from "~/components/common/data-form.vue";
import { Prop, Watch } from "vue-property-decorator";
var workspaceModule = namespace("workspace");
var MessageBox = /** @class */ (function (_super) {
    __extends(MessageBox, _super);
    function MessageBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.taskDataSet = [];
        _this.downLoad = CommonService.downloadFile;
        _this.currentMessage = "";
        _this.hour = '';
        _this.minute = '';
        _this.second = '';
        _this.timestamp = '';
        _this.oo = '';
        return _this;
    }
    MessageBox.prototype.onVisibleChange = function (value) {
        if (value) {
            this.refreshData();
        }
    };
    /**
     * 刷新数据
     */
    MessageBox.prototype.refreshData = function () {
        var _this = this;
        this.taskBoxService
            .query(this.pageService)
            .subscribe(function (data) {
            _this.taskDataSet = data;
        });
    };
    /**
     * 获取行样式
     */
    MessageBox.prototype.getRowClass = function (scope, index) {
        return scope.row.taskStatus.toLowerCase();
    };
    /**
     * 初始化
     */
    MessageBox.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Prop()
    ], MessageBox.prototype, "visible", void 0);
    __decorate([
        Dependencies(TaskBoxService)
    ], MessageBox.prototype, "taskBoxService", void 0);
    __decorate([
        Dependencies(PageService)
    ], MessageBox.prototype, "pageService", void 0);
    __decorate([
        workspaceModule.Action
    ], MessageBox.prototype, "updateUnReadCount", void 0);
    __decorate([
        Watch("visible")
    ], MessageBox.prototype, "onVisibleChange", null);
    MessageBox = __decorate([
        Component({
            components: {
                DataForm: DataForm
            }
        })
    ], MessageBox);
    return MessageBox;
}(Vue));
export default MessageBox;
